import PropTypes from 'prop-types';
import { Icon, PageTitle } from '@fasstech/middle-design-system';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer.jsx';

// Vue coquille « Garanties » de la prévoyance collective : layout et navigation, sans données
const SimulationWarrantiesGroupProtectionForm = ({ getMiddleText }) => {
  const { context, processHandlers } = useProcess();
  const transitionContext = { context: { projectId: context?.projectId } };

  return (
    <div className={'w-full'}>
      <PageLayout>
        <div className={'flex flex-col items-center gap-4'}>
          <Icon name={'bag'} />
          <PageTitle>Garanties</PageTitle>
        </div>
      </PageLayout>
      <ButtonContainer
        $onPreviousButtonClick={() => processHandlers.onPrev(transitionContext)}
        $onNextButtonClick={() => processHandlers.onNext(transitionContext)}
        nextButtonLabel={getMiddleText('GENERAL_COMMON_TEXTS_NEXT_BUTTON_LABEL')}
        displayPreviousButton
        getMiddleText={getMiddleText}
      />
    </div>
  );
};

SimulationWarrantiesGroupProtectionForm.propTypes = {
  getMiddleText: PropTypes.func
};

export default SimulationWarrantiesGroupProtectionForm;
